// letterLessons.js
//
// The ordered lesson plan. Letters are grouped by shared base shape (the dotted
// families), easy → hard. This is the single source of truth for ordering and
// grouping — edit here to reshape the curriculum.

export const letterLessons = [
  {
    id: 'alef',
    title: 'Alef & joining basics',
    letters: ['ا', 'آ'],
    note: 'Some letters never connect to the next one. Alef is the first of them.'
  },
  {
    id: 'be-family',
    title: 'The “tooth” family',
    letters: ['ب', 'پ', 'ت', 'ث'],
    note: 'One shape, told apart only by the dots above or below.'
  },
  {
    id: 'jim-family',
    title: 'The Jim family',
    letters: ['ج', 'چ', 'ح', 'خ'],
    note: 'A bowl shape; the dot’s place changes the sound.'
  },
  {
    id: 'dal-re',
    title: 'Non-joiners: Dal, Re & friends',
    letters: ['د', 'ذ', 'ر', 'ز', 'ژ', 'و'],
    note: 'These connect only on the right — they never join the next letter.'
  },
  {
    id: 'sin-sad',
    title: 'Sin & Sad families',
    letters: ['س', 'ش', 'ص', 'ض'],
    note: 'Wide shapes with teeth (Sin) or a loop (Sad).'
  },
  {
    id: 'ta-za',
    title: 'Ta & Za',
    letters: ['ط', 'ظ'],
    note: 'An upright stroke on a loop.'
  },
  {
    id: 'ain-fe-qaf',
    title: 'Ain, Ghain, Fe, Qaf',
    letters: ['ع', 'غ', 'ف', 'ق'],
    note: 'Open shapes that change a lot between positions.'
  },
  {
    id: 'kaf-lam',
    title: 'Kaf, Gaf, Lam',
    letters: ['ک', 'گ', 'ل'],
    note: 'Tall strokes.'
  },
  {
    id: 'meem-noon-he-ye',
    title: 'Meem, Noon, He, Ye',
    letters: ['م', 'ن', 'ه', 'ی'],
    note: 'The last set — rounded shapes and the long vowels.'
  }
];

export function getLesson(id) {
  return letterLessons.find((l) => l.id === id) || null;
}
